// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function geo_region_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var pickup_polygon = Decco.arrayFromJson((function (param) {
          return Decco.arrayFromJson((function (param) {
                        return Decco.arrayFromJson(Decco.floatFromJson, param);
                      }), param);
        }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "pickup_polygon"), null));
  if (pickup_polygon.TAG === /* Ok */0) {
    var drop_polygon = Decco.arrayFromJson((function (param) {
            return Decco.arrayFromJson((function (param) {
                          return Decco.arrayFromJson(Decco.floatFromJson, param);
                        }), param);
          }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "drop_polygon"), null));
    if (drop_polygon.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                pickup_polygon: pickup_polygon._0,
                drop_polygon: drop_polygon._0
              }
            };
    }
    var e = drop_polygon._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".drop_polygon" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = pickup_polygon._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".pickup_polygon" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var geo_region = geo_region_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "geo_region"), null));
  if (geo_region.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              geo_region: geo_region._0
            }
          };
  }
  var e = geo_region._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".geo_region" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  geo_region_decode ,
  t_decode ,
  
}
/* No side effect */
